import { useLanguageStore } from '$/store/languageStore';

/** 不可复制的具体业务原因统一使用产品文案，不能反过来决定是否显示公开预览入口。 */
export function getFeaturedCopyDisabledText(_reason?: string): string {
  const translate = useLanguageStore.getState().languageStore.smartcatTranslationText;
  return translate((value) => value.this_case_can_only_be_viewed_for_now_and_cannot_be_copied_to_my_project);
}

/** 首页、详情和只读预览的接口异常统一使用产品错误提示，错误码仍由调用方控制流程。 */
export function getFeaturedErrorText(_error: unknown): string {
  const translate = useLanguageStore.getState().languageStore.smartcatTranslationText;
  return translate((value) => value.loading_failed_please_try_again_later);
}
